import React, { useState, useEffect, useCallback, useRef } from 'react';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import config from '../config/config'; 
import axiosInstance from "../axiosConfig";
import "../styles/loader.css";
import Loader from "../components/Loader";
import { set } from "react-hook-form";
import { toast } from 'react-toastify';
import ReCAPTCHA from "react-google-recaptcha";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const BookingInfo = () => {
  const [activeDiv, setActiveDiv] = useState(null);

  const handleDivClick = divId => {
    setActiveDiv(divId);
  };

  const [activeBox, setActiveBox] = useState("choosestaffbox");

  const handleBoxClick = boxId => {
    setActiveBox(boxId);
  };

  const [activeButton, setActiveButton] = useState("btn1");
  const [staffList, setStaffList] = useState([]);
  const [defaultStaffId, setDefaultStaffId] = useState(() => {
    if (staffList.length > 0) {
        return staffList[0].id;
    }
    return null;
  });
  const [activeStaffId, setActiveStaffId] = useState(defaultStaffId);
  const [selectedDate, setSelectedDate] = useState('');
  const [availableSlots, setAvailableSlots] = useState({});
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [googleMapsUrl, setGoogleMapsUrl] = useState("");
  const [categories, setCategories] = useState([]);
  const [packages, setPackages] = useState([]);
  const [services, setServices] = useState([]);
  const [variations, setVariations] = useState([]);
  const [selectedItemsMale, setSelectedItemsMale] = useState([]);
  const [selectedItemsFemale, setSelectedItemsFemale] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeCategory, setActiveCategory] = useState("");
  const [deposit , setDeposit] = useState(0);
  const [total , setTotal] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const recaptchaRef = useRef(null);
  const navigate = useNavigate(); 

  //   const handleButtonClick = buttonId => {
  //     setActiveButton(buttonId);
  //   };

  // fetch categories
  useEffect(
    () => {
      const fetchCategories = async () => {
        try {
          const gender = activeButton === "btn1" ? "male" : "female";
          setLoading(true);
          const response = await axiosInstance.get(
            `/service-categories?gender=${gender}`
          );
          if (response.data.success) {
            setCategories(response.data.categories);
            setPackages(response.data.packages);
            if (response.data.categories.length > 0) {
              setActiveCategory(response.data.categories[0].id);
            }
          } else {
            setError(response.data.error || "Error fetching categories");
          }
        } catch (error) {
          setError("An error occurred while fetching the categories");
        } finally {
          setLoading(false);
        }
      };

      if (activeButton) {
        fetchCategories();
      }
    },
    [activeButton]
  );

  //fetch services when the active category
  useEffect(
    () => {
      const fetchServices = async () => {
        if (!activeCategory) return;

        try {
          const gender = activeButton === "btn1" ? "male" : "female";
          setLoading(true);
          const response = await axiosInstance(
            `/service-details?gender=${gender}&category=${activeCategory}`
          );
          if (response.data.success) {
            setServices(response.data.services);
            setVariations(response.data.variations);
          } else {
            setError(response.data.error || "Error fetching services");
          }
        } catch (error) {
          setError("An error occurred while fetching the services");
        } finally {
          setLoading(false);
        }
      };

      fetchServices();
    },
    [activeCategory, activeButton]
  );

  //fetch stores
  useEffect(() => {
    const fetchstores = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get("/store-list");
        if (response.data.success) {
          setStores(response.data.store);
        } else {
          setError(response.data.error || "Error fetching stores");
        }
      } catch (error) {
        setError("An error occurred while fetching the stores");
      } finally {
        setLoading(false);
      }
    };

    fetchstores();
  }, []);

  //  fetch staff members
  useEffect(() => {
    const fetchstaffs = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get("/staffs");
        if (response.data.success) {
          const staffData = response.data.staffs;
          setStaffList(staffData);
          setDefaultStaffId(null);
          setActiveStaffId(null);
        } else {
          setError(response.data.error || "Error fetching staffs");
        }
      } catch (error) {
        setError("An error occurred while fetching the staff");
      } finally {
        setLoading(false);
      }
    };

    fetchstaffs();
  }, []);

  useEffect(() => {
    if (activeStaffId && selectedDate) {
      let totalTime = 0; 

      const maleServiceTime = selectedItemsMale.reduce((acc, service) => {
        return acc + (Number(service.serviceTime) || 0); 
      }, 0);
      
      const femaleServiceTime = selectedItemsFemale.reduce((acc, service) => {
        return acc + (Number(service.serviceTime) || 0); 
      }, 0);

      totalTime += maleServiceTime + femaleServiceTime;

        axiosInstance.post('staff/slots', {
            user_id: activeStaffId,
            date: selectedDate,
            total_service_time: totalTime
        })
            .then(response => {
                if (response.data.success) {
                    setAvailableSlots(response.data.avaiabilityArr);
                } else {
                    toast.error(response.data.msg);
                    console.log(response.data.msg);
                    setAvailableSlots({});
                }
            })
            .catch(error => console.error('Error fetching availability:', error));
    }
}, [activeStaffId, selectedDate]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCaptchaChange = (token) => {
    setFormData({ ...formData, captchaToken: token });
    //setErrors({ ...errors, captchaToken: null }); // Clear CAPTCHA error if any
};

  // submit booking
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.captchaToken) {
      // setErrors({ ...errors, captchaToken: 'Please complete the CAPTCHA.' });
      // return;
      return toast.error('Please complete the CAPTCHA.');
    }
      if(!selectedStore) return toast.error('Please select a store.'); //selectedStore
      if (!activeStaffId) return toast.error('Please select a staff member.');
      if (!mergedServices || mergedServices.length === 0 || mergedServices === ',') {
        return toast.error('Please select valid services.');
      }
      if (!selectedDate) return toast.error('Please select a date.');
      if (!activeDiv) return toast.error('Please select a time slot.');
      if (!formData.name || !formData.email || !formData.phone)
        return toast.error('All fields are required.');

      let totalTime = 0; 

      const maleServiceTime = selectedItemsMale.reduce((acc, service) => {
        return acc + (Number(service.serviceTime) || 0); 
      }, 0);
      
      const femaleServiceTime = selectedItemsFemale.reduce((acc, service) => {
        return acc + (Number(service.serviceTime) || 0); 
      }, 0);

      totalTime += maleServiceTime + femaleServiceTime;

      const finalAppForm = {
        store_id: selectedStore,
        services: mergedServices,
        staff_id: activeStaffId,
        date: selectedDate,
        booked_start_slot: activeDiv,
        total_time: totalTime,
        totalpaydeposit: deposit,
        total: total,
        ...formData,
      };

      try {
        const response  = await axiosInstance.post(
            'appointments',
            finalAppForm
        );

        if (response.data.success) {

            // const paymentResponse = await axiosInstance.post('initiate-payment', { amount: deposit,appointment_id:response.data.id, ...formData });
            // if (paymentResponse.data.success) {
            //   toast.success('Payment initiated. Redirecting...');
            //   window.location.href = paymentResponse.data.redirect_url; 
            // } else {
            //   toast.error('Failed to initiate payment.');
            // }
            toast.success(response.data.message);
            // Reset all states to initial values
            setActiveStaffId(defaultStaffId);
            setSelectedDate('');
            setAvailableSlots({});
            setSelectedItemsMale([]);
            setSelectedItemsFemale([]);
            setActiveDiv('');
            setFormData({
                name: '',
                email: '',
                phone: '',
                message: '',
            });
            recaptchaRef.current.reset();
            navigate('/thank-you');

        } else {
            toast.error('Failed to create appointment.');
        }
    } catch (error) {
        console.error('Error submitting form:', error);
        toast.error('An error occurred. Please try again.');
    }


  }

const handleDateChange = (e) => {
  setSelectedDate(e.target.value);
};

  const handleButtonClick = buttonId => {
    console.log("Button clicked, switching to tab:", buttonId);
    setActiveButton(buttonId);
    setActiveCategory("");
    setServices([]);
  };

  const handleCategoryClick = categoryId => {
    setActiveCategory(categoryId);
  };

  useEffect(() => {
    const totalPrice = [...selectedItemsMale, ...selectedItemsFemale].reduce(
      (total, item) => total + Number(item.price),
      0
    );
    const calculatedDeposit = Math.floor(totalPrice);
    // const calculatedDeposit = Math.floor(totalPrice / 2);
    setDeposit(calculatedDeposit);
    setTotal(totalPrice);
  }, [selectedItemsMale, selectedItemsFemale]);
  
  // Function  checkbox change
  const handleCheckboxChange = (itemName, type, price,serviceTime) => {
    if (activeButton === "btn1") {
      // Male Tab
      setSelectedItemsMale(prevSelected => {
        const isItemSelected = prevSelected.some(
          item => item.name === itemName && item.type === type
        );
        if (isItemSelected) {
          return prevSelected.filter(
            item => item.name !== itemName || item.type !== type
          );
        } else {
          return [...prevSelected, { name: itemName, type, price,serviceTime }];
        }
      });
    } else if (activeButton === "btn2") {
      // Female Tab
      setSelectedItemsFemale(prevSelected => {
        const isItemSelected = prevSelected.some(
          item => item.name === itemName && item.type === type
        );
        if (isItemSelected) {
          return prevSelected.filter(
            item => item.name !== itemName || item.type !== type
          );
        } else {
          return [...prevSelected, { name: itemName, type, price,serviceTime }];
        }
      });
    }
  };

  // Function to merge male and female selections into one string
  const mergeSelections = () => {
    const maleItems = selectedItemsMale.map(item => `${item.name}`).join(',');
    const femaleItems = selectedItemsFemale.map(item => `${item.name}`).join(',');
    return `${maleItems},${femaleItems}`;
  }

  const mergedServices = mergeSelections();
   // filter staff based on selected store and services
   useEffect(() => {
    const filterStaffByServices = async (selectedStore, mergedServices) => {
      try {
        if (!selectedStore || !mergedServices) {
          console.log('Store or services are not selected.');
          return; 
        }
    
        const response = await axiosInstance.post('/filterStaff', {
          store: selectedStore,
          services: mergedServices,
        });
        if (response.data.success) {
          const staffData = response.data.staffs;
          setStaffList(staffData);
          setDefaultStaffId(null);
          setActiveStaffId(null);
        } else {
          setError(response.data.error || "Error fetching staffs");
        }
    
        console.log('Filtered staff:', response.data);
      } catch (error) {
        toast.error("Staff not found");
        setActiveStaffId('');
        setDefaultStaffId('');
        setStaffList([]);
        console.error('Error filtering staff:', error);
      }
    };
    
    if (selectedStore && mergedServices !== null && mergedServices !== ',') {
      filterStaffByServices(selectedStore, mergedServices);
    }
  }, [selectedStore, mergedServices]);
 


  // Function to remove an item from the selected list
  const handleRemoveItem = (itemName, type, price) => {
    if (activeButton === "btn1") {
      setSelectedItemsMale(prevSelected =>
        prevSelected.filter(
          item => item.name !== itemName || item.type !== type
        )
      );
    } else if (activeButton === "btn2") {
      setSelectedItemsFemale(prevSelected =>
        prevSelected.filter(
          item => item.name !== itemName || item.type !== type
        )
      );
    }
  };

  const [activeDropdown, setActiveDropdown] = useState(false);
  const [selectedValue1, setSelectedValue1] = useState("Select Store");
  const [dataValue1, setDataValue1] = useState(null);
  const [selectedValue2, setSelectedValue2] = useState("Select Staff");
  const [dataValue2, setDataValue2] = useState(null);

  
  const dropdownItems1 = stores.map(store => ({
    value: store.id,
    store_name:`${config.appName}`,
    label: store.store_name,
    url: store.store_name
  }));

  const handleStaffClick = (staffId) => {
    setActiveStaffId(staffId);
    setActiveDiv(null);

  }

  // Function to toggle dropdown visibility
  const toggleDropdown = (dropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  const applySelectedStore = useCallback((item) => {
    setSelectedValue1(item.label);
    setDataValue1(item.value);
    const generatedUrl = `https://www.google.com/maps?q=${encodeURIComponent(
      item.store_name
    )}+${encodeURIComponent(item.url)}`;
    setGoogleMapsUrl(generatedUrl);
    setSelectedStore(item.value);
  }, []);

  const handleItemClick1 = (item) => {
    setActiveDropdown(false);
    console.log("Item clicked:", item);
    applySelectedStore(item);
};

  const handleClickOutside = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
    if (stores.length > 0 && !selectedStore) {
      const firstStore = stores[0];
      applySelectedStore({
        value: firstStore.id,
        label: firstStore.store_name,
        store_name: `${config.appName}`,
        url: firstStore.store_name
      });
    }
  }, [stores, selectedStore, applySelectedStore]);

  //Staff dropdown
  // const dropdownItems2 = staffList.map(staff => ({
  //   value: staff.id,
  //   label: staff.name,
  // }));

  const [selectedStaff, setSelectedStaff] = useState(null);
  const dropdownItems2 = staffList.map(staff => {
    const hasValidImage = staff.profile_img_url && staff.profile_img_url.split('/').pop();
    return {
      value: staff.id,
      label: staff.name,
      img: hasValidImage
          ? staff.profile_img_url
          : "/assets/images/team/default.png"
    };
  });

  const handleItemClick2 = (item) => {
      setSelectedValue2(item.label);
      setDataValue2(item.value);
      setActiveDropdown(null);
      setActiveStaffId(item.value);
      setSelectedStaff(item);
      // setActiveDiv(null);
      console.log("Dropdown 2 Item clicked:", item);
  };

  useEffect(() => {
    if (staffList.length === 0) {
      setSelectedValue2("Select Staff");
      setDataValue2(null);
      setSelectedStaff(null);
      return;
    }

    setSelectedValue2("Select Staff");
    setDataValue2(null);
    setSelectedStaff(null);
    setDefaultStaffId(null);
    setActiveStaffId(null);
  }, [staffList]);


  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  if(loading){
    return <Loader />;
  }


  return (
    <section id="section-form" className="no-top no-bottom services-tab services-pricing booking-tab">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12 col-xl-11 col-xxl-10">
            <h3 className="s2">Choose Services</h3>
            <div className="store-location ctm-select">
              <div className="select-dropdown">
                <button type="button" className="select-dropdown-button" onClick={(e) => { e.stopPropagation(); toggleDropdown("dropdown1"); }} data-value={dataValue1}>
                    <span>{selectedValue1}</span>
                    <i className="fa-solid fa-angle-down"></i>
                </button>
                {activeDropdown === "dropdown1" && (
                  <ul className="select-dropdown-list">
                      {dropdownItems1.map((item) => (
                          <li
                              key={item.value}
                              data-value={item.value}
                              className="select-dropdown-list-item"
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleItemClick1(item);
                              }}
                          >
                              {item.label}
                          </li>
                      ))}
                  </ul>
                )}
            </div>
              <a
                className="btn-main"
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-solid fa-location-dot" /> Current Location
              </a>
            </div>

            {/* //Male Female button */}
            <div className="services-btn-tab">
              <button
                id="btn1"
                className={`services-btn ${activeButton === "btn1"
                  ? "active"
                  : ""}`}
                onClick={() => handleButtonClick("btn1")}
              >
                <img src="assets/images/male-face-icon.png" alt="Male" />Male
              </button>
              <button
                id="btn2"
                className={`services-btn ${activeButton === "btn2"
                  ? "active"
                  : ""}`}
                onClick={() => handleButtonClick("btn2")}
              >
                <img
                  src="assets/images/woman-face-icon.png"
                  alt="Female"
                />Female
              </button>
            </div>

            {/* //Male code start */}
            <div
              id="div1"
              style={{ display: activeButton === "btn1" ? "block" : "none" }}
            >
              <div className="row justify-content-center">
                <div className="col-lg-4">
                  <div className="services-tab-box">
                    <ul className="nav flex-column nav-pills">
                      {categories.map(category =>
                        <li className="nav-item" key={category.id}>
                          <button
                            className={`nav-link ${activeCategory ===
                            category.id
                              ? "active"
                              : ""}`}
                            onClick={() => handleCategoryClick(category.id)}
                          >
                            {category.name}
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-8">
                  {activeCategory &&
                    <div className="tab-content">
                      {services.map(category =>
                        <div
                          className="tab-pane fade show active"
                          id={category.name.replace(/\s+/g, "")}
                          key={category.id}
                        >
                          <div className="services-name-list">
                            {Array.isArray(category.services) &&
                              category.services.length > 0 &&
                              <div>
                                <ul>
                                  {Array.isArray(category.services) &&
                                    category.services.map((service, index) =>
                                      <li key={index}>
                                        <div className="services-name">
                                          <div>
                                            {service.name}
                                            {service.footnote &&
                                              service.footnote.trim() !== "" &&
                                              <span>
                                                ({service.footnote})
                                              </span>}
                                          </div>
                                        </div>
                                        <div className="services-price">
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={service.name}
                                              id={`flexCheckDefault${index}`}
                                              checked={
                                                activeButton === "btn1"
                                                  ? selectedItemsMale.some(
                                                      item =>
                                                        item.name ===
                                                        service.name
                                                    )
                                                  : selectedItemsFemale.some(
                                                      item =>
                                                        item.name ===
                                                        service.name
                                                    )
                                              }
                                              onChange={() =>
                                                handleCheckboxChange(
                                                  service.name,
                                                  "service",
                                                  service.price,
                                                  service.service_time
                                                )}
                                            />
                                            <label
                                              className="form-check-label"
                                              for={`flexCheckDefault${index}`}
                                            >
                                              ₹{service.price}
                                            </label>
                                          </div>
                                        </div>
                                      </li>
                                    )}
                                </ul>
                              </div>}
                            {Array.isArray(category.subcategories) &&
                              category.subcategories.length > 0 &&
                              <div>
                                {category.subcategories.map(
                                  (subcategory, subcategoryIndex) =>
                                    <div key={subcategoryIndex}>
                                      <h3>
                                        {subcategory.name}
                                      </h3>
                                      {Array.isArray(subcategory.services) &&
                                        subcategory.services.length > 0 &&
                                        <ul>
                                          {subcategory.services.map(
                                            (service, serviceIndex) =>
                                              <li key={serviceIndex}>
                                                <div className="services-name">
                                                  <div>
                                                    {service.name}
                                                    {service.footnote &&
                                                      service.footnote.trim() !==
                                                        "" &&
                                                      <span>
                                                        ({service.footnote})
                                                      </span>}
                                                  </div>
                                                </div>
                                                <div className="services-price">
                                                  <div className="form-check">
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      value={service.name}
                                                      id={`flexCheckDefault${serviceIndex}`}
                                                      checked={
                                                        activeButton === "btn1"
                                                          ? selectedItemsMale.some(
                                                              item =>
                                                                item.name ===
                                                                service.name
                                                            )
                                                          : selectedItemsFemale.some(
                                                              item =>
                                                                item.name ===
                                                                service.name
                                                            )
                                                      }
                                                      onChange={() =>
                                                        handleCheckboxChange(
                                                          service.name,
                                                          "subcategory",
                                                          service.price,
                                                          service.service_time
                                                        )}
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      for={`flexCheckDefault${serviceIndex}`}
                                                    >
                                                      ₹{service.price}
                                                    </label>
                                                  </div>
                                                </div>
                                              </li>
                                          )}
                                        </ul>}
                                    </div>
                                )}
                              </div>}
                          </div>
                        </div>
                      )}
                    </div>}
                </div>
              </div>
              <div className="row justify-content-center">
                {packages.map((pkg, index) =>
                  <div className="col-sm-10 col-md-6 col-lg-4 text-center">
                    <div className="price-main">
                      <div className="price-text">
                        <h3>
                          {pkg.name}
                        </h3>
                        <div className="round-shape" />
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={pkg.name}
                            id={`flexCheckDefault${index}`}
                            checked={
                              activeButton === "btn1"
                                ? selectedItemsMale.some(
                                    item => item.name === pkg.name
                                  )
                                : selectedItemsFemale.some(
                                    item => item.name === pkg.name
                                  )
                            }
                            onChange={() =>
                              handleCheckboxChange(
                                pkg.name,
                                "package",
                                Math.floor(pkg.price),
                                pkg.service_time
                              )}
                          />
                        </div>
                        <h2>
                          ₹{Math.floor(pkg.price)}
                        </h2>
                      </div>
                      <div className="price-bottom">
                        <ul>
                          {pkg.services
                            ? pkg.services.split(",").map((
                                service,
                                index // Split
                              ) =>
                                <li key={index}>
                                  <span>{service.trim()}</span>{" "}
                                </li>
                              )
                            : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* //Female Tab code start */}
            <div
              id="div2"
              style={{ display: activeButton === "btn2" ? "block" : "none" }}
            >
              <div className="row justify-content-center">
                <div className="col-lg-4">
                  <div className="services-tab-box">
                    <ul className="nav flex-column nav-pills">
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeCategory === null ? 'active' : ''}`}
                          onClick={() => handleCategoryClick(null)}
                        >
                          <span>Hair Size</span>
                        </button>
                      </li>
                      {categories.map(category =>
                        <li className="nav-item" key={category.id}>
                          <button
                            className={`nav-link ${activeCategory ===
                            category.id
                              ? "active"
                              : ""}`}
                            onClick={() => handleCategoryClick(category.id)}
                          >
                            <span>{category.name}</span>
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-8">
                  {activeCategory === null && (
                    <div className="tab-content">
                          <div className='tab-pane fade show active' id="hair-size-tab" role='tabpanel' aria-labelledby='hair-size-tab'>
                            <div className="row justify-content-center">
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/pixie.png"
                                    alt="pixie"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>pixie</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/bob.png"
                                    alt="bob"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>bob</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/short.png"
                                    alt="short"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>short</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/medium.png"
                                    alt="medium"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>medium</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-6 col-md-4 col-lg-4">
                                <div className="hair-style">
                                  <img
                                    src="assets/images/long.png"
                                    alt="long"
                                    className="img-fluid"
                                  />
                                  <div className="hair-style-content">
                                    <div className="hair-style-name">
                                      <span>long</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                    </div>
                  )}
                  {activeCategory &&
                    <div className="tab-content">
                      {services.map(category =>
                        <div
                          className="tab-pane fade show active"
                          id={category.name.replace(/\s+/g, "")}
                          key={category.id}
                        >
                          
                          <div className="cat-package">
                            {Array.isArray(variations) &&
                              variations.length > 0 &&
                              variations.map((variation, index) =>
                                <div key={index}>
                                  <div className="cat-package-title">
                                    {variation.name}
                                  </div>
                                </div>
                              )}
                          </div>
                          <div className="services-name-list">
                            {Array.isArray(category.services) &&
                              category.services.length > 0 &&
                              <div>
                                <ul>
                                  {Array.isArray(category.services) &&
                                    category.services.map((service, index) =>
                                      <li key={index}>
                                        <div className="services-name">
                                          <div>
                                            {service.name}
                                            {service.footnote &&
                                              service.footnote.trim() !== "" &&
                                              <span>
                                                ({service.footnote})
                                              </span>}
                                          </div>
                                        </div>
                                        <div className="services-price">
                                          {(!Array.isArray(
                                            service.service_variationsnew
                                          ) ||
                                            service.service_variationsnew
                                              .length === 0) &&
                                            <div className="form-check">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value={service.name}
                                                id={`flexCheckDefault${index}`}
                                                checked={
                                                  activeButton === "btn1"
                                                    ? selectedItemsMale.some(
                                                        item =>
                                                          item.name ===
                                                          service.name
                                                      )
                                                    : selectedItemsFemale.some(
                                                        item =>
                                                          item.name ===
                                                          service.name
                                                      )
                                                }
                                                onChange={() =>
                                                  handleCheckboxChange(
                                                    service.name,
                                                    "service",
                                                    service.price,
                                                    service.service_time
                                                  )}
                                              />
                                              <label
                                                className="form-check-label"
                                                for={`flexCheckDefault${index}`}
                                              >
                                                ₹{service.price}
                                              </label>
                                            </div>}
                                        </div>
                                        {Array.isArray(
                                          service.service_variationsnew
                                        ) &&
                                          service.service_variationsnew.length >
                                            0 &&
                                          <div className="services-price waxing">
                                            {service.service_variationsnew.map(
                                              (variation, variationIndex) =>
                                                <div
                                                  key={variationIndex}
                                                  className="form-check"
                                                >
                                                  {variation.variation_price == 0 ? (
                                                    '--'
                                                  ) : (
                                                    <>
                                                      <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value={variation.name}
                                                        id={`flexCheckDefaultVariation${variationIndex}`}
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        htmlFor={`flexCheckDefaultVariation${variationIndex}`}
                                                      >
                                                        ₹{variation.variation_price}
                                                      </label>
                                                    </>
                                                  )}
                                                </div>
                                            )}
                                          </div>}
                                      </li>
                                    )}
                                </ul>
                              </div>}
                            {Array.isArray(category.subcategories) &&
                              category.subcategories.length > 0 &&
                              <div>
                                {category.subcategories.map(
                                  (subcategory, subcategoryIndex) =>
                                    <div key={subcategoryIndex}>
                                      <h3>
                                        {subcategory.name}
                                      </h3>
                                      {Array.isArray(subcategory.services) &&
                                        subcategory.services.length > 0 &&
                                        <ul>
                                          {subcategory.services.map(
                                            (service, serviceIndex) =>
                                              <li key={serviceIndex}>
                                                <div className="services-name">
                                                  <div>
                                                    {service.name}
                                                    {service.footnote &&
                                                      service.footnote.trim() !==
                                                        "" &&
                                                      <span>
                                                        ({service.footnote})
                                                      </span>}
                                                  </div>
                                                </div>
                                                <div className="services-price">
                                                  <div className="form-check">
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      value={service.name}
                                                      id={`flexCheckDefault${serviceIndex}`}
                                                      checked={
                                                        activeButton === "btn1"
                                                          ? selectedItemsMale.some(
                                                              item =>
                                                                item.name ===
                                                                service.name
                                                            )
                                                          : selectedItemsFemale.some(
                                                              item =>
                                                                item.name ===
                                                                service.name
                                                            )
                                                      }
                                                      onChange={() =>
                                                        handleCheckboxChange(
                                                          service.name,
                                                          "subcategory",
                                                          service.price,
                                                          service.service_time
                                                        )}
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      for={`flexCheckDefault${serviceIndex}`}
                                                    >
                                                      ₹{service.price}
                                                    </label>
                                                  </div>
                                                </div>
                                              </li>
                                          )}
                                        </ul>}
                                    </div>
                                )}
                              </div>}
                          </div>
                        </div>
                      )}
                    </div>
                  }
                </div>
              </div>
              <div className="row justify-content-center">
                {packages.map((pkg, index) =>
                  <div className="col-sm-10 col-md-6 col-lg-4 text-center">
                    <div className="price-main">
                      <div className="price-text">
                        <h3>
                          {pkg.name}
                        </h3>
                        <div className="round-shape" />
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={pkg.name}
                            id={`flexCheckDefault${index}`}
                            checked={
                              activeButton === "btn1"
                                ? selectedItemsMale.some(
                                    item => item.name === pkg.name
                                  )
                                : selectedItemsFemale.some(
                                    item => item.name === pkg.name
                                  )
                            }
                            onChange={() =>
                              handleCheckboxChange(
                                pkg.name,
                                "package",
                                Math.floor(pkg.price),
                                pkg.service_time
                              )}
                          />
                        </div>
                        <h2>
                          ₹{Math.floor(pkg.price)}
                        </h2>
                      </div>
                      <div className="price-bottom">
                        <ul>
                          {pkg.services
                            ? pkg.services.split(",").map((
                                service,
                                index // Split
                              ) =>
                                <li key={index}>
                                  <span>{service.trim()}</span>{" "}
                                </li>
                              )
                            : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Cart Selected Service Code start */}
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <h3 className="s2">Selected Items</h3>
                <div className="selected-service-box">
                  <div className="cart-section">
                    {(selectedItemsMale.length === 0 && selectedItemsFemale.length === 0)
                      ? <p>No items selected</p>
                      : <>
                          {/* Male services section */}
                          {selectedItemsMale.length > 0 && (
                            <div className="male-services">
                              <h4>Male Services</h4>
                              <ul>
                                {selectedItemsMale.map((item, index) => (
                                  <li key={index}>
                                    <span className="service-nme">{item.name}</span>
                                    <div className="ms-auto">
                                      <span> ₹{item.price}</span>
                                      <button
                                        onClick={() => handleRemoveItem(item.name, item.type, item.price)}
                                      >
                                        <i className="fa-solid fa-xmark"></i>
                                      </button>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}

                          {/* Female services section */}
                          {selectedItemsFemale.length > 0 && (
                            <div className="female-services">
                              <h4>Female Services</h4>
                              <ul>
                                {selectedItemsFemale.map((item, index) => (
                                  <li key={index}>
                                    <span className="service-nme">{item.name}</span>
                                    <div className="ms-auto">
                                      <span> ₹{item.price}</span>
                                      <button
                                        onClick={() => handleRemoveItem(item.name, item.type, item.price)}
                                      >
                                        <i className="fa-solid fa-xmark"></i>
                                      </button>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}

                          {/* Total price section */}
                          <div className="total-price">
                            <h4>
                              Total:
                              <span> ₹{Math.floor(
                                [...selectedItemsMale, ...selectedItemsFemale].reduce(
                                  (total, item) => total + Number(item.price),
                                  0
                                )
                              )}</span>
                            </h4>
                            {/* <h5>
                              Pay Deposit: 
                              <span>₹{Math.floor(
                                [...selectedItemsMale, ...selectedItemsFemale].reduce(
                                  (total, item) => total + Number(item.price),
                                  0
                                ) / 2
                              )}</span>
                            </h5> */}
                          </div>
                        </>
                    }
                  </div>
                </div>
              </div>
            </div>
            {/* Cart Selected Service Code end */}
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-12 col-xl-11 col-xxl-10">
            <form
              name="contactForm"
              id="contact_form"
              className="form-border"
              method="post"
              onSubmit={handleSubmit}
            >
              <div className="spacer-single" />
              <div className="row">
                  <div className="col-lg-8">
                      {
                        (selectedItemsMale.length > 0 || selectedItemsFemale.length > 0) && (
                          <>
                            <div className="mb-sm-30">
                              <h3 className="s2">Choose Staff</h3>
                              <div className="ctm-select">
                                <div className="select-dropdown w-100">
                                  <button
                                    type="button"
                                    className="select-dropdown-button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleDropdown("dropdown2");
                                    }}
                                    data-value={dataValue2}
                                  >
                                    <span>{selectedValue2}</span>
                                    <i className="fa-solid fa-angle-down"></i>
                                  </button>
                                  {
                                    (selectedItemsMale.length > 0 || selectedItemsFemale.length > 0) && activeDropdown === "dropdown2" && (
                                      <ul className="select-dropdown-list">
                                        {dropdownItems2.map((item) => (
                                          <li
                                            key={item.value}
                                            data-value={item.value}
                                            className="select-dropdown-list-item"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleItemClick2(item);
                                            }}
                                          >
                                            {item.label}
                                          </li>
                                        ))}
                                      </ul>
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                              <div className="spacer-single" />

                              <div className="mb-sm-30">
                                  <h3 className="s2">Select Date</h3>
                                  <input
                                    type="date"
                                    name="date"
                                    id="date"
                                    className="form-control"
                                    placeholder="dd/mm/yyyy"
                                    min={new Date().toISOString().split('T')[0]} // Prevents selecting past dates
                                    required
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                  />
                              </div>
                                
                              <div className="spacer-single" />

                              <div className='mb-sm-30'>
                                <h3 className="s2">Select Time</h3>
                                  <div className="select-time-box">
                                    <ul>
                                      {Object.keys(availableSlots).map((timeSlot) => {
                                        const available = availableSlots[timeSlot];

                                        return (
                                          <li 
                                            key={timeSlot} 
                                            className={`${activeDiv === timeSlot ? "active" : ""}`} 
                                            onClick={() => handleDivClick(timeSlot)}
                                          >
                                            {timeSlot}
                                            {/* {timeSlot} - Available: {available} slots */}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </div>
                              </div>
                          </>
                        )
                      }
                  </div>
           
                <div className="col-lg-4 d-flex align-items-start justify-content-center">
                  <div className="staff-preview">
                    <img src={selectedStaff?.img || "/assets/images/team/default.png" } alt="Staff Preview" style={{ width: "180px" ,
                      height: "180px" , objectFit: "cover" , border: "2px solid var(--primary-color)" , borderRadius: "8px" , }} />
                  </div>
                </div>
              </div>
              <div className="spacer-single" />
              <div className="row">
                <h3 className="s2">Your details</h3>
                <div className="col-lg-6">
                  <div id="name_error" className="error">
                    Please enter your name.
                  </div>
                  <div className="mb25">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="form-control"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div id="email_error" className="error">
                    Please enter your valid E-mail ID.
                  </div>
                  <div className="mb25">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      className="form-control"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div id="phone_error" className="error">
                    Please enter your phone number.
                  </div>
                  <div className="mb25">
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      className="form-control"
                      placeholder="Your Phone"
                      value={formData.phone} 
                      onChange={handleInputChange} 
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div id="message_error" className="error">
                    Please enter your message.
                  </div>
                  <div>
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      placeholder="Your Message"
                      value={formData.message} 
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-lg-12 text-center">
                  {/* <div
                    className="g-recaptcha"
                    data-sitekey="6LdW03QgAAAAAJko8aINFd1eJUdHlpvT4vNKakj6"
                    align="center"
                  /> */}
                    <ReCAPTCHA
                      sitekey="6Lc2WrEqAAAAAKr1qfvZAimn-b0LAzNabkkT4vIO"
                      onChange={handleCaptchaChange}
                      ref={recaptchaRef}
                  />
                  <p id="submit" className="mt20">
                    <input
                      type="submit"
                      id="send_message"
                      value={`Book Now`}
                      // value={`Book & Pay: ${deposit}`}
                      className="btn-main"
                    />
                  </p>
                </div>
              </div>
            </form>
            <div id="success_message" className="success">
              Your message has been sent successfully. Refresh this page if you
              want to send more messages.
            </div>
            <div id="error_message" className="error">
              Sorry there was an error sending your form.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingInfo;
